import { Component, Input } from '@angular/core';

export interface ActionButton {
  label: string;
  icon?: string;
  handler: () => void;
}

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  standalone: false,
})
export class PageComponent {
  @Input() pageTitle: string;
  @Input() showRequestReviewButton = true;
  @Input() primaryActionButton: ActionButton;
  @Input() secondaryActionButton: ActionButton;
}
